/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";

import type { ButtonHTMLAttributes } from "react";

const MD_ICON = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 14.6669L20.6669 10L22 11.3331L17.3331 16L22 20.6669L20.6669 22L16 17.3331L11.3331 22L10 20.6669L14.6669 16L10 11.3331L11.3331 10L16 14.6669Z"
      fill="#A3A3A3"
    />
  </svg>
);

export const CloseButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button css={styles.button} type="button" className="md" {...props}>
      {MD_ICON}
    </button>
  );
};
const styles = {
  button: css`
    border: none;
    padding: 0;
    border-color: transparent;
    background-color: transparent;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
    &.md {
      width: 32px;
      height: 32px;
    }
  `,
};
